// src/i18n/translations.js
// Version: 1.3.4 - Added translation for Duplicate Rule

export const translations = {
  ja: {
    // ... (all existing ja translations from your v1.3.3) ...
    chatWelcome: "ようこそ！",
    nextQuestion: "次へ",
    submitAnswers: "回答を送信",
    thankYouMessage: "ご回答ありがとうございました！",
    startOver: "最初からやり直す",
    companyName: "会社名",
    contactName: "担当者名",
    position: "役職",
    emailAddress: "メールアドレス",
    industry: "会社の業界",
    confirmInfo: "情報収集を希望しますか？",
    yes: "はい",
    no: "いいえ",
    freeTextPlaceholder: "こちらに入力してください...",
    emailPlaceholder: "メールアドレスを入力",
    other: "その他",
    pleaseSpecify: "具体的に入力してください:",
    dateInputLabel: "日付を選択してください:",
    correctAnswer: "訂正する",
    botAvatarChar: "ボ",
    userAvatarChar: "ユ",
    loading: "読み込み中",
    editLastAnswer: "最後の回答を編集",
    closeChat: "チャットを閉じる",
    appIdNotConfiguredError: "アプリケーションIDが設定されていません。",
    invalidQuestionnaireFormatError: "無効なアンケート形式です。",
    currentQuestionMissingError: "現在の質問が見つかりません。",
    inputRequiredError: "この項目は必須です。",
    invalidEmailError: "有効なメールアドレスを入力してください。",
    invalidDateError: "有効な日付を入力してください。",
    noAnswerToEditError: "編集する回答が見つかりませんでした。",
    chatClosedNotification: "チャットが閉じられました（シミュレーション）。",
    questionnaireDefaultTitle: "アンケート",
    attemptingToCloseChat: "チャットを閉じています...",
    pleaseCloseWindowManually: "チャットウィンドウ/タブを手動で閉じてください。",


    // Admin
    adminLogin: "管理者ログイン",
    adminPanel: "管理者パネル",
    email: "メールアドレス",
    password: "パスワード",
    login: "ログイン",
    logout: "ログアウト",
    dashboard: "ダッシュボード",
    questionnaireSets: "質問セット管理",
    mediaManagement: "メディア管理",
    emailTemplates: "メールテンプレート",
    emailAttachments: "メール添付ファイル",
    emailSendingRules: "メール送信条件",
    reports: "レポート",
    clientsReports: "クライアントレポート",
    language: "言語",
    english: "English",
    japanese: "日本語",
    addNewSet: "新しいセットを追加",
    activateSet: "有効化",
    deactivateSet: "無効化",
    editSet: "編集",
    deleteSet: "削除",
    duplicateSet: "複製",
    active: "有効",
    inactive: "無効",
    setName: "セット名",
    addQuestion: "質問を追加",
    deleteQuestion: "質問を削除",
    moveUp: "上へ移動",
    moveDown: "下へ移動",
    questionText: "質問内容",
    questionType: "質問タイプ",
    selectType: "Select Type",
    multipleChoice: "選択式",
    freeText: "自由記述",
    emailInput: "メールアドレス入力",
    dateInput: "日付入力",
    statement: "説明文 (質問なし)",
    options: "選択肢",
    addOption: "選択肢を追加",
    allowOther: "「その他」の自由記述を許可する",
    questionImageUrl: "質問画像URL",
    optionImageUrl: "選択肢画像URL",
    imagePreview: "画像プレビュー",
    save: "保存",
    cancel: "キャンセル",
    confirmDelete: "本当に削除しますか？",
    confirmDeleteTitle: "削除の確認",
    confirmDeleteMsg: "このアイテムを本当に削除してもよろしいですか？この操作は元に戻せません。",
    uploadFile: "ファイルをアップロード",
    fileName: "ファイル名",
    fileUrl: "ファイルURL",
    preview: "プレビュー",
    actions: "操作",
    templateName: "テンプレート名",
    subject: "件名",
    body: "本文 (HTML)",
    attachmentName: "添付ファイル名",
    addRule: "ルールを追加",
    autosend: "自動送信",
    on: "ON",
    off: "OFF",
    conditions: "条件",
    addCondition: "条件を追加",
    question: "質問",
    answer: "回答",
    selectQuestion: "質問を選択",
    responses: "回答一覧",
    downloadCsv: "CSVダウンロード",
    downloadExcel: "Excelダウンロード (CSV)",
    filterBySet: "セットで絞り込み",
    allSets: "全てのセット",
    date: "日時",
    noData: "データがありません。",
    uploadCsv: "CSVアップロード",
    downloadFormat: "フォーマットダウンロード",
    manageUserEmailRequirements: "メール送信条件の管理 (UserEmailRequirements)",
    q_companySize: "会社規模を教えてください。",
    opt_under10: "１０人未満",
    opt_11to30: "１１～３０人",
    opt_31to70: "３１～７０人",
    opt_71to100: "７１～１００人",
    opt_over100: "１００人以上",
    q_recruiter: "採用活動を行っている人はどなたですか？",
    opt_representative: "代表",
    opt_executive: "役員／取締役",
    opt_specialist: "採用専門担当者",
    opt_concurrentStaff: "総務／経理／庶務部などの担当者が兼任",
    opt_contractor: "業務委託者など",
    q_recruitmentTime: "採用活動にはどのくらいの時間をかけていますか？",
    opt_lessThan1h: "週１時間未満",
    opt_1to2h: "週１～２時間程度",
    opt_3to5h: "週３～５時間程度",
    opt_over6h: "週６時間以上",
    q_recruitmentBudget: "採用活動の予算はどのくらいかけていますか？",
    opt_lessThan50k: "月額５万円未満",
    opt_60kTo100k: "月額６万～１０万円",
    opt_110kTo200k: "月額１１万～２０万円",
    opt_over210k: "月額２１万円以上",
    q_monthlyApplications: "月間の応募状況はどのくらいですか？",
    opt_under1: "１件以下",
    opt_2to3: "２件～３件程度",
    opt_4to5: "４件～５件程度",
    opt_6to9: "６件～９件程度",
    opt_over10: "１０件以上",
    q_candidateQuality: "応募人材は採用したい人材ですか？",
    opt_qualityVeryLow: "積極的に採用したい人材は非常に少ない",
    opt_qualityLow: "積極的に採用したい人材はあまり来ない",
    opt_qualityMedium: "積極的に採用したい人材はそこそこ集まる",
    opt_qualityHigh: "応募の内容は積極的に採用したい人材であることが多い",
    opt_qualityNone: "応募がほとんどない／ない",
    q_turnoverRate: "採用後の離職率は平均どのくらいですか？",
    opt_turnover3m: "３ヵ月以内に退職するケースが多い",
    opt_turnover3to6m: "３ヵ月～６ヵ月以内に退職するケースが多い",
    opt_turnover6mto1y: "６ヵ月～１年以内に退職するケースが多い",
    opt_turnover1yto3y: "１年以上３年未満に退職するケースが多い",
    opt_turnoverOver3y: "３年以上継続するケースが多い",
    q_collectInfo: "下記の回答をもらう",
    q_companyIndustry: "会社の業界を教えてください。",
    q_newsletter: "今後、中小企業採用に役立つ情報の取得（当方からの配信コンテンツ）を希望しますか？",
    errorOccurred: "エラーが発生しました。",
    success: "成功しました。",
    fileUploaded: "ファイルがアップロードされました。",
    ruleSaved: "ルールが保存されました。",
    itemDeleted: "アイテムが削除されました。",
    loginFailed: "ログインに失敗しました。",
    adminAccountNote: "注: 初回ログイン時は、管理者アカウント (〇〇〇〇) が自動的に作成されます。パスワードは 〇〇〇〇 を使用してください。",
    noQuestionSets: "利用可能な質問セットがありません。管理者が設定してください。",
    uploading: "アップロード中...",
    deleting: "削除中...",
    saving: "保存中...",
    ruleConditionInfo: "回答が指定された値と一致する場合にメールが送信されます。空の場合はどの回答でもOKです。",
    emailFileNameEms: "メールファイル名 (.html/.txt)",
    fileAttachmentPdf: "添付ファイル (.pdf)",
    dataExported: "データがエクスポートされました。",
    reportInfo: "ユーザーがアンケートに回答すると、ここにデータが表示されます。",
    questionSetManagementInfo: "チャットボットで使用する質問セットを作成、編集、有効化します。一度に有効化できるセットは1つだけです。",
    mediaManagementInfo: "送信メールに使用するテンプレートと添付ファイルを管理します。",
    emailRulesInfo: "ユーザーの回答に基づいてメールを自動送信するためのルールを設定します。",
    viewUserResponses: "ユーザー回答の表示",
    createdAt: "作成日時",
    updatedAt: "更新日時",
    lastAnswered: "最終回答日時",
    totalResponses: "総回答数",
    activeQuestionSet: "有効な質問セット",
    status: "ステータス",
    noActiveSet: "有効なセットがありません",
    confirmActivationTitle: "有効化の確認",
    confirmActivationMsg: "この質問セットを有効にしますか？現在有効な他のセットはすべて無効になります。",
    emailTemplateBodyInfo: "HTML形式でメール本文を作成します。プレースホルダー (例: {{companyName}}) を使用して動的コンテンツを挿入できます。",
    attachmentInfo: "PDFファイルをアップロードしてください。",
    userEmailRequirementsInfo: "CSV形式: Autosend (on/off), EmailAddress, EmailTemplateName, AttachmentName, Question1ID:Answer1Value, Question2ID:Answer2Value,...",
    csvHelperText: "各質問の条件は 'QuestionID:ExpectedAnswer' の形式で指定します。例: company_size:under10",
    viewLogs: "ログを見る (未実装)",
    sendTestEmail: "テストメール送信 (未実装)",
    errorLoadingData: "データの読み込み中にエラーが発生しました。",
    noQuestionnaireFound: "アクティブなアンケートが見つかりません。",
    manage: "管理",
    any: "任意",
    errorUniqueQuestionId: "エラー: このセット内の質問IDは一意で、空であってはなりません。",
    errorEmptyQuestionId: "エラー: すべての質問には空でないIDが必要です。",
    quickActions: "クイックアクション",
    systemStatus: "システムステータス",
    dateOperatorOn: "特定の日",
    dateOperatorBefore: "以前",
    dateOperatorAfter: "以降",
    dateOperatorBetween: "期間内",
    and: "と",
    editLastAnswerAriaLabel: "最後の回答を編集する",
    startOverAriaLabel: "最初からやり直す",
    closeChatAriaLabel: "チャットを閉じる",

    // For EmailSendingRules (v1.2.0+)
    ruleNameOptional: "ルール名（任意）",
    recipientEmailPlaceholder: "recipient@example.com",
    emailTemplate: "メールテンプレート",
    selectTemplate: "テンプレートを選択",
    emailAttachmentOptional: "メール添付ファイル（任意）",
    selectAttachmentOptional: "添付ファイルを選択（任意）",
    keepBccCopy: "送信メールのコピーをBCCで受信する",
    filterQuestionsBySet: "質問をセットで絞り込む",
    selectQuestionSetToFilter: "質問をリストするセットを選択",
    selectQuestionSetToFilterAll: "すべてのセット / セットを選択して絞り込む",
    pleaseSelectSetFirst: "まず質問セットを選択してください",
    selectQuestionToAddCondition: "条件に追加する質問を選択",
    answerValuePlaceholder: "回答の値",
    answerValue2Placeholder: "回答の値2（期間の場合）",
    operatorEquals: "等しい",
    noRulesDefined: "メール送信ルールはまだ定義されていません。",
    unnamedRule: "無名のルール",
    sendsTo: "送信先:",
    confirmDeleteRuleMsg: "このルールを本当に削除してもよろしいですか？",
    errorSavingRule: "ルールの保存中にエラーが発生しました",
    errorDeletingRule: "ルールの削除中にエラーが発生しました",
    ruleAdded: "ルールが追加されました",
    selectDifferentQuestionForCondition: "別の質問を選択するか、この質問の条件は既に存在します。",
    pleaseSelectQuestionToAdd: "条件に追加する質問を選択してください。",
    conditionAlreadyExistsForQuestion: "この質問の条件は既に存在します。",
    pleaseSelectSetAndQuestion: "セットを選択し、利用可能な質問があることを確認してください。",
    editRule: "ルールを編集",
    emailAddressRequiredError: "メールアドレスは必須です。",
    saveRuleWithoutConditionsConfirm: "このルールには条件がありません。自動送信がONの場合、常にトリガーされます。保存しますか？",
    filterBySetOrNoQuestions: "セットで絞り込むか、利用可能な質問がありません。",
    selectSetToRefineList: "上のドロップダウンでセットを選択すると、このリストが絞り込まれます。",
    duplicateRule: "ルールを複製", 
    copySuffix: "のコピー", 
    ruleDuplicated: "ルールが複製されました。",
    errorDuplicatingRule: "ルールの複製中にエラーが発生しました。"
  },
  en: {
    // ... (all existing en translations from your v1.3.1) ...
    chatWelcome: "Welcome!",
    nextQuestion: "Next",
    submitAnswers: "Submit Answers",
    thankYouMessage: "Thank you for your responses!",
    startOver: "Start Over",
    companyName: "Company Name",
    contactName: "Contact Name",
    position: "Position",
    emailAddress: "Email Address",
    industry: "Company Industry",
    confirmInfo: "Do you want to receive information?",
    yes: "Yes",
    no: "No",
    freeTextPlaceholder: "Enter here...",
    emailPlaceholder: "Enter email address",
    other: "Other",
    pleaseSpecify: "Please specify:",
    dateInputLabel: "Please select a date:",
    correctAnswer: "Correct Answer",
    botAvatarChar: "B",
    userAvatarChar: "U",
    loading: "Loading",
    editLastAnswer: "Edit Last Answer",
    closeChat: "Close Chat",
    appIdNotConfiguredError: "Application ID not configured.",
    invalidQuestionnaireFormatError: "Invalid questionnaire format.",
    currentQuestionMissingError: "Current question is missing.",
    inputRequiredError: "This field is required.",
    invalidEmailError: "Please enter a valid email address.",
    invalidDateError: "Please enter a valid date.",
    noAnswerToEditError: "Could not find an answer to edit.",
    chatClosedNotification: "Chat closed (simulation).",
    questionnaireDefaultTitle: "Questionnaire",
    attemptingToCloseChat: "Attempting to close window/tab...",
    pleaseCloseWindowManually: "Please manually close the window/tab if it's still open.",

    // Admin
    adminLogin: "Admin Login",
    adminPanel: "Admin Panel",
    email: "Email",
    password: "Password",
    login: "Login",
    logout: "Logout",
    dashboard: "Dashboard",
    questionnaireSets: "Questionnaire Sets",
    mediaManagement: "Media Management",
    emailTemplates: "Email Templates",
    emailAttachments: "Email Attachments",
    emailSendingRules: "Email Sending Rules",
    reports: "Reports",
    clientsReports: "Client Reports",
    language: "Language",
    english: "English",
    japanese: "日本語",
    addNewSet: "Add New Set",
    activateSet: "Activate",
    deactivateSet: "Deactivate",
    editSet: "Edit",
    deleteSet: "Delete",
    duplicateSet: "Duplicate Rule",
    active: "Active",
    inactive: "Inactive",
    setName: "Set Name",
    addQuestion: "Add Question",
    deleteQuestion: "Delete Question",
    moveUp: "Move Up",
    moveDown: "Move Down",
    questionText: "Question Text",
    questionType: "Question Type",
    selectType: "Select Type",
    multipleChoice: "Multiple Choice",
    freeText: "Free Text",
    emailInput: "Email Input",
    dateInput: "Date Input",
    statement: "Statement (No Question)",
    options: "Options",
    addOption: "Add Option",
    allowOther: "Allow 'Other' text input",
    questionImageUrl: "Question Image URL",
    optionImageUrl: "Option Image URL",
    imagePreview: "Image Preview",
    save: "Save",
    cancel: "Cancel",
    confirmDelete: "Are you sure you want to delete this?",
    confirmDeleteTitle: "Confirm Deletion",
    confirmDeleteMsg: "Are you sure you want to delete this item? This action cannot be undone.",
    uploadFile: "Upload File",
    fileName: "File Name",
    fileUrl: "File URL",
    preview: "Preview",
    actions: "Actions",
    templateName: "Template Name",
    subject: "Subject",
    body: "Body (HTML)",
    attachmentName: "Attachment Name",
    addRule: "Add Rule",
    autosend: "Autosend",
    on: "ON",
    off: "OFF",
    conditions: "Conditions",
    addCondition: "Add Condition",
    question: "Question",
    answer: "Answer",
    selectQuestion: "Select Question",
    responses: "Responses",
    downloadCsv: "Download CSV",
    downloadExcel: "Download Excel (CSV)",
    filterBySet: "Filter by Set",
    allSets: "All Sets",
    date: "Date",
    noData: "No data available.",
    uploadCsv: "Upload CSV",
    downloadFormat: "Download Format",
    manageUserEmailRequirements: "Manage User Email Requirements",
    q_companySize: "Please tell us your company size.",
    opt_under10: "Less than 10 people",
    opt_11to30: "11-30 people",
    opt_31to70: "31-70 people",
    opt_71to100: "71-100 people",
    opt_over100: "Over 100 people",
    q_recruiter: "Who is in charge of recruitment activities?",
    opt_representative: "Representative",
    opt_executive: "Executive/Director",
    opt_specialist: "Recruitment Specialist",
    opt_concurrentStaff: "Staff from General Affairs/Accounting/Admin (concurrent role)",
    opt_contractor: "Contractor, etc.",
    q_recruitmentTime: "How much time do you spend on recruitment activities?",
    opt_lessThan1h: "Less than 1 hour/week",
    opt_1to2h: "About 1-2 hours/week",
    opt_3to5h: "About 3-5 hours/week",
    opt_over6h: "Over 6 hours/week",
    q_recruitmentBudget: "What is your budget for recruitment activities?",
    opt_lessThan50k: "Less than 50,000 JPY/month",
    opt_60kTo100k: "60,000-100,000 JPY/month",
    opt_110kTo200k: "110,000-200,000 JPY/month",
    opt_over210k: "Over 210,000 JPY/month",
    q_monthlyApplications: "What is your monthly application status?",
    opt_under1: "1 or less",
    opt_2to3: "About 2-3",
    opt_4to5: "About 4-5",
    opt_6to9: "About 6-9",
    opt_over10: "10 or more",
    q_candidateQuality: "Are the applicants the talent you want to hire?",
    opt_qualityVeryLow: "Very few candidates we actively want to hire",
    opt_qualityLow: "Not many candidates we actively want to hire",
    opt_qualityMedium: "A fair number of candidates we actively want to hire",
    opt_qualityHigh: "Applicants are often talent we actively want to hire",
    opt_qualityNone: "Almost no/no applications",
    q_turnoverRate: "What is the average turnover rate after hiring?",
    opt_turnover3m: "Many leave within 3 months",
    opt_turnover3to6m: "Many leave within 3-6 months",
    opt_turnover6mto1y: "Many leave within 6 months to 1 year",
    opt_turnover1yto3y: "Many leave within 1 to 3 years",
    opt_turnoverOver3y: "Many stay for over 3 years",
    q_collectInfo: "Collect the following answers",
    q_companyIndustry: "Please tell us your company's industry.",
    q_newsletter: "Would you like to receive information useful for SME recruitment (content distributed by us) in the future?",
    errorOccurred: "An error occurred.",
    success: "Success!",
    fileUploaded: "File uploaded successfully.",
    ruleSaved: "Rule saved successfully.",
    itemDeleted: "Item deleted successfully.",
    loginFailed: "Login failed.",
    adminAccountNote: "Note: On first login, the admin account (〇〇〇〇) will be created automatically. Use password 〇〇〇〇.",
    noQuestionSets: "No available questionnaire sets. Please configure them in the admin panel.",
    uploading: "Uploading...",
    deleting: "Deleting...",
    saving: "Saving...",
    ruleConditionInfo: "Email will be sent if the answer matches the specified value. Leave blank for any answer.",
    emailFileNameEms: "Email File Name (.html/.txt)",
    fileAttachmentPdf: "File Attachment (.pdf)",
    dataExported: "Data exported successfully.",
    reportInfo: "Data will appear here as users complete questionnaires.",
    questionSetManagementInfo: "Create, edit, and activate questionnaire sets for the chatbot. Only one set can be active at a time.",
    mediaManagementInfo: "Manage templates and attachments for emails.",
    emailRulesInfo: "Set up rules to automatically send emails based on user responses.",
    viewUserResponses: "View User Responses",
    createdAt: "Created At",
    updatedAt: "Updated At",
    lastAnswered: "Last Answered",
    totalResponses: "Total Responses",
    activeQuestionSet: "Active Question Set",
    status: "Status",
    noActiveSet: "No active set",
    confirmActivationTitle: "Confirm Activation",
    confirmActivationMsg: "Are you sure you want to activate this questionnaire set? All other active sets will be deactivated.",
    emailTemplateBodyInfo: "Create email body in HTML. You can use placeholders like {{companyName}} for dynamic content.",
    attachmentInfo: "Please upload PDF files.",
    userEmailRequirementsInfo: "CSV format: Autosend (on/off), EmailAddress, EmailTemplateName, AttachmentName, Question1ID:Answer1Value, Question2ID:Answer2Value,...",
    csvHelperText: "Specify conditions for each question as 'QuestionID:ExpectedAnswer'. E.g., company_size:under10",
    viewLogs: "View Logs (Not Implemented)",
    sendTestEmail: "Send Test Email (Not Implemented)",
    errorLoadingData: "Error loading data.",
    noQuestionnaireFound: "No active questionnaire found.",
    manage: "Manage",
    any: "Any",
    errorUniqueQuestionId: "Error: Question IDs within this set must be unique and not empty.",
    errorEmptyQuestionId: "Error: All questions must have a non-empty ID.",
    quickActions: "Quick Actions",
    systemStatus: "System Status",
    dateOperatorOn: "On Date",
    dateOperatorBefore: "Before",
    dateOperatorAfter: "After",
    dateOperatorBetween: "Between",
    and: "and",
    editLastAnswerAriaLabel: "Edit last answer",
    startOverAriaLabel: "Start over questionnaire",
    closeChatAriaLabel: "Close chat interface",

    // For EmailSendingRules (v1.2.0+)
    ruleNameOptional: "Rule Name (Optional)",
    recipientEmailPlaceholder: "recipient@example.com",
    emailTemplate: "Email Template",
    selectTemplate: "Select Template",
    emailAttachmentOptional: "Email Attachment (Optional)",
    selectAttachmentOptional: "Select Attachment (Optional)",
    keepBccCopy: "Keep a copy of every sent email (BCC to admin)",
    filterQuestionsBySet: "Filter Questions by Set",
    selectQuestionSetToFilter: "--- Select Set to List Questions ---",
    selectQuestionSetToFilterAll: "All Sets / Select to Filter",
    pleaseSelectSetFirst: "Please select a question set first",
    selectQuestionToAddCondition: "Select Question to Add Condition",
    answerValuePlaceholder: "Answer Value",
    answerValue2Placeholder: "Answer Value 2 (for between)",
    operatorEquals: "Equals",
    noRulesDefined: "No email sending rules defined yet.",
    unnamedRule: "Unnamed Rule",
    sendsTo: "Sends to:",
    confirmDeleteRuleMsg: "Are you sure you want to delete this rule?",
    errorSavingRule: "Error saving rule",
    errorDeletingRule: "Error deleting rule",
    ruleAdded: "Rule added successfully",
    selectDifferentQuestionForCondition: "Please select a different question or a condition for this question already exists.",
    pleaseSelectQuestionToAdd: "Please select a question to add a condition.",
    conditionAlreadyExistsForQuestion: "A condition for this question already exists.",
    pleaseSelectSetAndQuestion: "Please select a set and ensure questions are available.",
    editRule: "Edit Rule",
    emailAddressRequiredError: "Email address is required.",
    saveRuleWithoutConditionsConfirm: "This rule has no conditions. If 'Autosend' is ON, it will always trigger. Save anyway?",
    filterBySetOrNoQuestions: "Filter by set or no questions available",
    selectSetToRefineList: "Select a set above to refine this list, or choose from all available non-statement questions.",
    duplicateRule: "Duplicate Rule",
    copySuffix: " - Copy", 
    ruleDuplicated: "Rule duplicated successfully!",
    errorDuplicatingRule: "Error duplicating rule."
  }
};
